import fetch from './http';
export default {

  /**
     * [用户开始注册时先检查手机号是否已注册]
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     */
  checkMobileExists(params) {
    return fetch.fetchPost('api/user/seller/v1/user/checkmobileexists', params);
  },

  /**
   * [用户注册]
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  usersRegister(params) {
    return fetch.fetchPost('api/user/seller/v1/user/usersregister', params);
  },


  /**
     * 获取平台标识
     * @param  {[type]} params [description]
     * @return {[type]}        [description]
     */
  getPlatforms(params) {
    return fetch.fetchGet('api/config/v1/platforms/get', params);
  },

  /**
   * 根据平台唯一标识获取平台信息
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getPlatFormsInfo(params) {
    return fetch.fetchGet('api/config/v1/platforms/get2', params);
  },

  /**
   * 根据头信息获取平台信息
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getPlatFormsInfoByHeader(params) {
    return fetch.fetchGet('api/config/v1/platforms/getbyheader', params);
  },
  /**
 * 获取主营类目/商品类目信息
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
  getGoodsCategoryList(params) {
    return fetch.fetchGet('api/config/v1/goodscategorys/getlist', params);
  },
  /**
 * 得到所有的省份列表
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
  getProvinceList(params) {
    return fetch.fetchGet('api/config/v1/region/getprovincelist', params);
  },

  /**
  * 得到所有的省市
  * @param  {[type]} params [description]
  * @return {[type]}        [description]
  */
  getregions(params, headers) {
    return fetch.fetchGet('api/config/v1/region/getregions', params);
  },
  /**
   * 创建店铺
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  createStore(params) {
    return fetch.fetchPost('api/store/seller/v1/shop/createstore', params);
  },
  /**
 * 获取平台模板列表
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
  getTemplateList(params) {
    return fetch.fetchGet('api/store/seller/v1/template/getlist', params);
  },

  /**
   * 获取账户信息
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getUserInfo(params) {
    return fetch.fetchGet('api/user/seller/v1/user/get', params);
  },
  /**
 * 获取店铺授权信息
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
  getShopSign(params) {
    return fetch.fetchGet('api/store/seller/v1/shop/getsign', params);
  },
  /**
 * 获取店铺信息
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
  getStoreInfo(params) {
    return fetch.fetchGet('api/store/seller/v1/shop/getstoreinfo', params);
  },
  /**
   * 发送验证码（旧）
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  sendCode(params) {
    return fetch.fetchPost('api/config/v1/tool/sendcode', params);
  },
  /**
 * 帐号密码登录
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
  loginByPassword(params) {
    return fetch.fetchPost('api/user/seller/v1/user/userloginbypassword', params);
  },
  /**
  * 获取滑块验证码
  * @param  {[type]} params [description]
  * @return {[type]}        [description]
  */
  slidergetcode(params) {
    return fetch.fetchGet('//api.youtaidu-dev.deiyou.net/api/captcha/v1/slider/getcode', params);
  },
  /**
    * 验证滑块验证码
    * @param  {[type]} params [description]
    * @return {[type]}        [description]
    */
  slidercheckcode(params) {
    return fetch.fetchPost('//api.youtaidu-dev.deiyou.net/api/captcha/v1/slider/checkcode', params);
  },

}
